import { render, staticRenderFns } from "./MesDashboardView.vue?vue&type=template&id=ffbdf5b0&"
import script from "./MesDashboardView.vue?vue&type=script&lang=js&"
export * from "./MesDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports